<template>
  <v-navigation-drawer v-model="drawer" app :width="nestedMode ? 320 : 300">
    <v-navigation-drawer
      v-model="drawer"
      absolute
      :color="nestedMode ? 'primary' : 'white'"
      :dark="nestedMode"
      :mini-variant="nestedMode"
      :style="{ transition: 'all 200ms' }"
      :width="300"
    >
      <div
        :class="nestedMode ? '' : 'px-4'"
        :style="{ transition: 'all 200ms' }"
      >
        <div class="py-12 px-6">
          <router-link to="/dashboard">
            <v-img
              :src="require('@/assets/logo-adveroo-blue.svg')"
              contain
              height="18"
              position="left center"
            />
          </router-link>
        </div>

        <v-list
          v-if="nestedMode"
          light
          :nav="!nestedMode"
          :dark="!nestedMode"
          class="mb-6"
        >
          <v-list-item
            link
            class="white"
            :class="nestedMode ? '' : 'primary'"
            :style="{
              borderRadius: nestedMode ? '' : '12px',
            }"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="font-weight-medium">
              Přidat
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <div v-else class="px-2 py-2 mb-6">
          <v-menu>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                class="c-btn"
                min-width="100%"
                :height="56"
              >
                Přidat
                <v-icon
                  right
                  medium
                  :style="{ fontSize: '24px' }"
                  class="ml-auto"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in createMenuItems"
                :key="index"
                @click="onMenuItemClick(item)"
              >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
                <v-list-item-icon>
                  <v-icon>mdi-plus</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-list :nav="!nestedMode">
          <v-list-item
            link
            v-for="item in menuItems"
            :key="item.route"
            :disabled="item.disabled"
            :to="item.link"
            class="my-1"
            :ripple="{ class: nestedMode ? '' : 'amber--text' }"
          >
            <v-list-item-icon>
              <component
                :is="`icon-menu-${item.icon}`"
                :class="[
                  'c-menu-icon',
                  nestedMode ? 'c-menu-icon--nested-mode' : '',
                ]"
              />
            </v-list-item-icon>
            <v-list-item-title
              :class="[
                'c-menu-text font-weight-medium',
                nestedMode ? 'c-menu-text--nested-mode' : '',
              ]"
            >
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <div class="py-12 pl-16 mx-6">
      <router-link to="/dashboard">
        <v-img
          :src="require('@/assets/logo-adveroo-blue.svg')"
          contain
          height="18"
          position="left center"
        />
      </router-link>
    </div>

    <div class="pl-16 mx-6">
      <ui-step-list class="pt-2" :items="stepItems" />
      <div class="tutorial-video mt-6" v-if="videoTutorial">
        <p class="font-weight-bold">Videotutoriál</p>
        <iframe
          :src="videoTutorial"
          width="208"
          height="120"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import UserMenu from "./UserMenu.vue"
import PageSelect from "./PageSelect.vue"
import IconMenuAds from "@/components/icon/menu/Ads.vue"
import IconMenuAudiences from "@/components/icon/menu/Audiences.vue"
import IconMenuCalc from "@/components/icon/menu/Calc.vue"
import IconMenuDashboard from "@/components/icon/menu/Dashboard.vue"
import IconMenuFaq from "@/components/icon/menu/Faq.vue"
import IconMenuMegaLauncher from "@/components/icon/menu/MegaLauncher.vue"
import IconMenuSmartAudiences from "@/components/icon/menu/SmartAudiences.vue"
import IconMenuTutorials from "@/components/icon/menu/Tutorials.vue"

const menuItems = [
  {
    link: "/dashboard",
    text: "Dashboard",
    icon: "dashboard",
  },
  {
    link: "/mega-launcher",
    text: "Mega launcher",
    icon: "mega-launcher",
    disabled: true,
  },
  {
    link: "/audiences",
    text: "Publika",
    icon: "audiences",
  },
  {
    link: "/smart-audiences",
    text: "Chytrá publika",
    icon: "smartAudiences",
  },
  {
    link: "/ads",
    text: "Reklamy",
    icon: "ads",
  },
  {
    link: "/calc",
    text: "Business kalkulačka",
    icon: "calc",
    disabled: true,
  },
  {
    link: "/tutorials",
    text: "Návody",
    icon: "tutorials",
  },
  {
    link: "/faq",
    text: "FAQ",
    icon: "faq",
  },
]

const createMenuItems = [
  {
    onClick: "onNewAudienceClick",
    text: "Nové publikum",
  },
  {
    onClick: "onNewAdClick",
    text: "Nová reklama",
  },
]

export default {
  components: {
    UserMenu,
    PageSelect,
    IconMenuAds,
    IconMenuAudiences,
    IconMenuCalc,
    IconMenuDashboard,
    IconMenuFaq,
    IconMenuMegaLauncher,
    IconMenuSmartAudiences,
    IconMenuTutorials,
  },
  data() {
    return {
      menuItems,
      createMenuItems,
    }
  },
  computed: {
    nestedMode() {
      return this.$route.meta.nestedMode ?? false
    },
    stepItems() {
      return this.$route.meta.drawerItems || []
    },
    ...sync("app", ["drawer"]),
    ...get("app", ["videoTutorial"]),
  },
  methods: {
    ...call("ads", ["clearAdModel"]),
    ...call("audiences", ["clearAudienceModel"]),
    onNewAdClick() {
      this.clearAdModel()
      this.$router.push("/ads/new")
    },
    onNewAudienceClick() {
      this.clearAudienceModel()
      this.$router.push("/audiences/new")
    },
    onMenuItemClick(item) {
      if (item.link) {
        this.$router.push(item.link)
      }
      if (item.onClick && this[item.onClick]) {
        this[item.onClick].call(this)
      }
    },
  },
}
</script>

<style scoped>
.v-list-item--link:before {
  background: #fef4e4;
  z-index: -1;
}

.v-list--nav .v-list-item--link:before {
  border-radius: 6px;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1;
}

.c-menu-icon {
  color: var(--v-navy-lighten1);
}

.c-menu-icon.c-menu-icon--nested-mode {
  color: white;
}

.v-list-item--active .c-menu-icon:not(.c-menu-icon--nested-mode) {
  color: var(--v-amber-base);
}

.c-menu-text {
  color: var(--v-primary-base);
}

.c-menu-text--nested-mode {
  color: white;
}

.v-list-item--disabled .c-menu-text {
  color: var(--v-navy-lighten1);
}

.v-list-item--disabled .c-menu-text--nested-mode {
  color: var(--v-navy);
}
</style>
